// extracted by mini-css-extract-plugin
module.exports = {"bar":"calc-result-bar_bar__oSsIg","label":"calc-result-bar_label__ydPy0","value":"calc-result-bar_value__o_9vn","jumpBtn":"calc-result-bar_jumpBtn__K__gr"};